import React, { Component } from "react";
import ReactTable from "react-table";
import "react-table/react-table.css";
import requester from "../../../lib/requester";
import { Loader } from "react-overlay-loader";
import "react-overlay-loader/styles.css";
import moment from "moment";
import _, { filter } from "lodash";
import ReactExport from "react-export-excel-hot-fix";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { faAlignRight } from "@fortawesome/free-solid-svg-icons";
import { text } from "@fortawesome/fontawesome-svg-core";
import request from "../../../lib/requester";
import Autocomplete from "../../../component/autocomplete";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class receiptdocument extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataTable: [],
      baseTable: [],
      search: "",
      user: JSON.parse(window.localStorage.getItem("is_user")),
      submittedDateFrom: "",
      submittedDateTo: "",
      sAwbNo: "",
      sCustomerId: "",
      sCustomerName: "",
    };
  }

  componentDidMount = () => {
    this.handleSearch();
  };

  handleSearch = () => {
    let url = "/api/collect/v1/monitoring/get-header-doc-cus-receipt";
    let param = {
      org_id: this.state.user.org_id,
      customer_id: this.state.sCustomerId,
      origin: this.state.user.origin
    };

    this.setState({ loading: true });
    requester.postCollect(url, param, {
      success: function (response) {
        let { data } = response.data;

        this.setState({
          loading: false,
          dataTable: data.header,
          baseTable: data.header,
          export: false,
        });
      }.bind(this),
      error: function (e) {
        this.setState({ loading: false });
      }.bind(this),
    });
    // this.getPrincipal();
    // this.getBranch();
  };

  renderTable = () => {
    const data = {
      columns: [
        {
          Header: "Document No.",
          accessor: "doc_no",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),

          //   width: 150,
        },
        {
          Header: "Doc Date",
          accessor: "doc_date",
          filterable: true,
          //   width: 150,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          // ,filterable: true
        },
        {
          Header: "Awb No.",
          accessor: "awb_no",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),

          //   width: 150,
        },
        {
          Header: "Awb Date",
          accessor: "awb_date",
          filterable: true,
          //   width: 150,

          Cell: (row) => (
            <span>
              <span>
                {row.value !== null && row.value !== "" && row.value !== "null"
                  ? moment(new Date(row.value)).format("DD-MMM-YYYY")
                  : ""}
              </span>
            </span>
          ),
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          // ,filterable: true
        },

        {
          Header: "Sender",
          accessor: "org_src_name",
          filterable: true,
          Filter: ({ filter, onChange }) => (
            <input
              placeholder="search.."
              onChange={(event) => onChange(event.target.value)}
              //   defaultValue="Search.."
              value={filter ? filter.value : ""}
              //   value="2111"
              style={{
                width: "100%",
                // backgroundColor: "gray",
                //   color: "gray",
              }}
            />
          ),
          //   width: 80,
        },

        {
          Header: "Action",
          accessor: "doc_id",
          //   filterable: true,
          //   width: 20,
          Cell: (row) => {
            return (
              <div style={{ textAlign: "center", color: "blue" }}>
                <span>
                  {/* <a
                    className="fa fa-list-alt"
                    onClick={() => this.goDetail(row.value)}
                    // onClick={() => alert("nahlo")}
                  >
                    view
                  </a> */}
                  <button
                    type="button"
                    className="btn btn-info btn-sm"
                    onClick={() => {
                      this.goDetail(row.value);
                    }}
                  >
                    View <i className="fas fa-eye" />
                  </button>
                </span>
              </div>
            );
          },
        },
      ],
      rows: this.state.dataTable,
    };
    return (
      <ReactTable
        className="fullWidth"
        data={data.rows}
        columns={data.columns}
        defaultPageSize={10}
        defaultFilterMethod={(filter, row, column) => {
          let columnes = row[filter.id];
          return columnes
            ? columnes.toLowerCase().includes(filter.value.toLowerCase())
            : "";
        }}
      />
    );
  };

  goDetail = (id) => {
    // let { row } = rows;
    this.props.history.push("/admin/documentmonitor/receiptcus/" + id);
  };

  onChangeAutocompleteCust = (q) => {
    let param = {
      branch_id: this.state.user.org_id,
      customer_name: q,
    };
    let container = [];
    return new Promise((resolve) => {
      request.postOracle("/api/orafin/v1/participant/customer", param, {
        success: function (response) {
          var api_response = response.data.data;
          container = api_response.map((item, index) => {
            item.text = item.CUSTOMER_NAME;
            item.value = item.CUSTOMER_ID;
            return item;
          });
          resolve(container);
        },
        error: function (e) {
          resolve([]);
        },
      });
    });
  };

  onSelectCustomer = (suggestions, index) => {
    this.state.sCustomerId = suggestions.value ? suggestions.value : null;
    this.state.sCustomerName = suggestions.text ? suggestions.text : null;
  };

  render() {
    return (
      <div>
        <section className="content">
          <div className="container-fluid">
            <div className="row ml-1">
              <div className="col-lg-12">
                <div className="card card-info">
                  <div className="card-header">List</div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-12">
                        {/* <div className="card">
                          <div className="card-body"></div>
                        </div> */}
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-md-6">
                        <div className="form-group row">
                          <label
                            htmlFor="inputEmail3"
                            className="col-sm-3 col-form-label"
                          >
                            Customer
                          </label>
                          <div className="col-sm-8">
                            <div className="col-sm-12">
                              <Autocomplete
                                onchange={this.onChangeAutocompleteCust.bind(
                                  this
                                )}
                                onselect={this.onSelectCustomer.bind(this)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group row">
                          <div className="col-md-9">
                            <div className="col-sm-8">
                              <button
                                type="button"
                                className="btn btn-success"
                                onClick={this.handleSearch.bind(this)}
                                // onClick={this.handleReopenpdf.bind(this)}
                              >
                                FIND
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* <hr /> */}
                    <div className="clearfix">&nbsp;</div>
                    <div className="row">
                      <div className="col-lg-12">{this.renderTable()}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Loader fullPage loading={this.state.loading} />
        </section>
      </div>
    );
  }
}

export default receiptdocument;
